import ImageOne from "../sgunis/Curtin.png";
import ImageTwo from "../sgunis/INSWORLD.png";
import ImageThree from "../sgunis/JAMES COOKE UNI.png";
import ImageFour from "../sgunis/MDIS.png";
import ImageFive from "../sgunis/NANYANG.jpeg";
import ImageSix from "../sgunis/PSB.jpg";
import ImageSeven from "../sgunis/Raffles.png";
import ImageEight from "../sgunis/SIM.webp";

const universities = [
    { id: 1, img: ImageOne, name: "Curtin Singapore" },
    { id: 2, img: ImageTwo, name: "INSWORLD INSTITUTE" },
    { id: 3, img: ImageThree, name: "JAMES COOK UNIVERSITY SINGAPORE" },
    { id: 4, img: ImageFour, name: "Manage Development Institute of Singapore" },
    { id: 5, img: ImageFive, name: "NANYANG INSTITUTE OF MANAGEMENT" },
    { id: 6, img: ImageSix, name: "Psb ACADEMY" },
    { id: 7, img: ImageSeven, name: "Raffles College of Higher Education" },
    { id: 8, img: ImageEight, name: "SIM Global Education" }
];

export default universities;
